/**
 * @group Constants
 * @internal
 *
 * @summary
 * <blockquote>Available console output formats</blockquote>
 *
 * @example
 * ```typescript
 * import { CONSOLE_FORMATS } from '@shared/reporting';
 *
 * console.log(CONSOLE_FORMATS.JSON); // 'json'
 * ```
 */
export const CONSOLE_FORMATS = {
  JSON: 'json',
  TEXT: 'text'
} as const;
